module.exports = __webpack_public_path__ + "img/zcyone.dd00f4cf.png";